module.exports = __webpack_public_path__ + "static/screenshot2-9d02a5122dd8682bc2c6dee822d38600.png";